module.exports = __webpack_public_path__ + "static/media/Icon_X.6b7a8ac2.svg";